import { createStore } from 'satcheljs';
import { defaultConfig } from '../util/defaultConfig';
import type { MailRibbonConfigStore } from './schema/mailRibbonConfigStore';

export const getStore = createStore<MailRibbonConfigStore>(
    'MailRibbonConfiguration',
    defaultConfig
);
export default getStore();
export { default as loadMailRibbonConfiguration } from '../actions/loadMailRibbonActions';
